<template>
  <div>
    <div class="bk">
      <!-- zz -->
      <div class="overlay"></div>
      <div class="one">智能交通</div>
      <div class="xian"></div>
      <div class="two">
        智能交通是一种综合运用信息技术、数据通信、传感器、控制技术和计算机科学等多领域先进技术。智能交通具有实时监控、预测分析、事件自动化决策等多种功能，通过各种信息获取设备，如摄像头、GPS、传感器等，实时收集相关数据，然后通过分析和处理，实施各种智能交通管理与控制措施。
      </div>
    </div>
    <div class="cecurity">
      <div class="title">运营车辆管理平台</div>
      <div class="content">
        <span>
          运营车辆管理平台是提供给运营车辆（如网约车，出租车，货车，巴士等）拥有者与相关监管者使用的车辆管理平台软件平台；平台功能模组包括但不限于实时视频播放，实时定位，录像点播，轨迹追踪，计价管理，设备管理等。</span
        >
      </div>
      <!-- <div  class="look">
                    <span><router-link :to="{path:'/technology'}">查看更多</router-link></span>
                </div> -->
      <!-- <div class="look">
        <span
          ><router-link :to="{ path: '/technology' }"
            >查看更多</router-link
          ></span
        >
        <img src="../assets/img/icon_more.svg" alt="" />
      </div> -->
    </div>
    <div class="three">
      <div></div>
      <!-- <div></div>
      <div></div> -->
    </div>

    <div class="architecture">
      <div class="title">车辆监管终端</div>
      <div class="content">
        <span>
          车辆监管终端
          车辆监管终端是安装在运营车辆上的车载硬件设备，包括但不限于满足905,808（需要引用正规叫法）的网约车智能终端，两客一危智能终端，车载传感器等
          ；车载终端根据实际需求会内嵌高级计算机算法如ADAS（先进驾驶辅助系统），DSM（司机状态监测），盲点检测等。昌恩自研的车辆监管终端RD11-2、RD112(有屏)、RD112(无屏)等。</span
        >
      </div>
      <!-- <div class="look">
        <span
          ><router-link :to="{ path: '/monitor' }">查看更多</router-link></span
        >
        <img src="../assets/img/icon_more.svg" alt="" />
      </div> -->
    </div>
    <div class="four">
      <div></div>
      <!-- <div></div> -->
      <div></div>
      <div></div>
    </div>
    <div class="air">
      <div class="title">科技治超</div>
      <div class="content">
        <span>
          科技治超是一种通过现代信息技术手段，对道路货运车辆进行智能化监管和执法的新型治理方式。科技治超的主要技术手段包括动态自动称重设施、电子抓拍系统、视频监控、交通流量调查、外廓尺寸检测等相关配套设施。在此业务线中，昌恩较有代表性的案例有：佛山市一环6座大桥科技治超建设项目、佛山市一体化治超管理平台建设项目等。
        </span>
      </div>
      <!-- <div class="look">
        <span
          ><router-link :to="{ path: '/administration' }"
            >查看更多</router-link
          ></span
        >
        <img src="../assets/img/icon_more.svg" alt="" />
      </div> -->
    </div>
    <div class="airthree">
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'architecture2',
  beforeRouteEnter (to, from, next) {
    // 执行路由进入时的滚动操作
    window.scrollTo({ top: 0 })
    next()
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.look {
  position: absolute;
}
.bk {
  position: relative;
  width: 100vw;
  height: 104vw;
  /* background-image: url(../assets/img/建筑智能化_banner_mob.png); */
  background-image: url(../assets/img/智能交通首页封面.png);
  background-size: cover;
}
.overlay {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 104vw;
  background: rgba(10, 11, 21, 0.4);
}
.bk .xian {
  position: absolute;
  top: 48.8vw;
  width: 97.3333vw;
  height: 0px;
  border: 1px solid;
  border-image: linear-gradient(
      90deg,
      rgba(255, 166, 3, 0),
      rgba(255, 166, 3, 1),
      rgba(255, 166, 3, 0)
    )
    3 3;
}
.bk .one {
  position: absolute;
  /* left:50%; */
  /* transform: translate(-50%,0); */
  width: 57.0667vw;
  left: 50%;
  margin-left: -28.50333vw;
  text-align: center;
  top: 34.1333vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 8vw;
  letter-spacing: 1.8667vw;
  font-size: 6.4vw;
}
.bk .two {
  position: absolute;
  width: 89.3333vw;
  height: 17.4667vw;
  top: 56.8vw;
  left: 5.3333vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  letter-spacing: 0.1333vw;
  font-size: 3.2vw;
  text-align: center;
  line-height: 5.3333vw;
}

.cecurity {
  position: relative;
  margin: 8vw auto 0;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}

.cecurity .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  color: #140047;
  font-family: AlibabaPuHuiTiB;
}

.cecurity .content {
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
}

.cecurity .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  color: #01021b;
  opacity: 0.72;
  font-family: PingFangSC-Regular, PingFang SC;
}
.cecurity .look {
  width: 29.3333vw;
  height: 8vw;
  margin-top: 8.2667vw;
  margin-left: 33.7333vw;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5333vw;
  border: 0.2667vw solid #140047;
}
.cecurity .look span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
}
.look span {
  float: left;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
}
.look img {
  float: left;
  width: 8vw;
  height: 8.5333vw;
  margin-left: 2.6667vw;
}
.three {
  margin: 4.2667vw auto 0;
  width: 92vw;
  height: 69.0667vw;
}

.three div:nth-child(1) {
  float: left;
  left: 0px;
  /* width: 43.7333vw; */
  width: 100%;
  height: 69.0667vw;
  background-image: url(../assets/img/车辆管理.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  /* background-position: center; */
  /* background-size: cover; */
  /* border: 1px dashed #808080; */
}
.three div:nth-child(2) {
  float: right;
  top: 0px;
  right: 0px;
  width: 44.2667vw;
  height: 32.5333vw;
  background-image: url(../assets/img/智能安防2_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}
.three div:nth-child(3) {
  float: right;
  margin-top: 4vw;
  right: 0px;
  width: 44.2667vw;
  height: 32.5333vw;
  background-image: url(../assets/img/智能安防3_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}
.architecture {
  position: relative;
  margin: 10.6667vw auto 0;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 0.2667vw 2.6667vw 0px rgba(176, 183, 213, 0.2);
}
.architecture .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  color: #140047;
  font-family: AlibabaPuHuiTiB;
}
.architecture .content {
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
}
.architecture .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  color: #01021b;
  opacity: 0.72;
  font-family: PingFangSC-Regular, PingFang SC;
}
.architecture .look {
  width: 29.3333vw;
  height: 8vw;
  margin-top: 16px;
  margin-left: 33.7333vw;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5333vw;
  border: 0.2667vw solid #140047;
}
.architecture .look span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
}
.four {
  margin: 4.2667vw auto 0;
  width: 92vw;
  height: 72.8vw;
}

.four div:nth-child(1) {
  float: left;
  width: 43.7333vw;
  /* height: 48vw; */
  height: 100%;
  background-image: url(../assets/img/终端2.jpg);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
  background-size: cover;
  background-position: center;
}
.four div:nth-child(3) {
  float: right;
  width: 44.2667vw;
  height: 11.7333vw;
  background-image: url(../assets/img/终端1.png);
  background-size: 100% 100%;
  background-size: cover;
  background-position: center;
  /* border: 1px dashed #808080; */
  margin-top: 4vw;
}
.four div:nth-child(2) {
  float: right;
  /* margin-top: 4vw; */
  right: 0px;
  width: 44.2657vw;
  height: 57.0667vw;
  background-image: url(../assets/img/终端3.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
  background-position: left;
  background-size: cover;
}
.four div:nth-child(4) {
  float: left;
  margin-top: 4vw;
  left: 0px;
  width: 43.7333vw;
  height: 20.5333vw;
  background-image: url(../assets/img/建筑智能化3_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}

.air {
  position: relative;
  margin: 20vw auto 0;
  width: 92vw;
  height: 54.6667vw;
  box-shadow: 0px 0.2667vw 2.6667vw 0px rgba(176, 183, 213, 0.2);
}
.air .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 4.2667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  color: #140047;
  font-family: AlibabaPuHuiTiB;
}
.air .content {
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
}
.air .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  color: #01021b;
  opacity: 0.72;
  font-family: PingFangSC-Regular, PingFang SC;
}
.air .look {
  width: 29.3333vw;
  height: 8vw;
  margin-top: 4.2667vw;
  margin-left: 33.7333vw;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.5333vw;
  border: 1px solid #140047;
}
.air .look span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
}
.airthree {
  margin: 4.2667vw auto 0;
  width: 92vw;
  height: 69.0667vw;
}
.airthree div:nth-child(1) {
  float: left;
  /* background-image: url(../assets/img/中央空调节能系统1_mob.png); */
  background: url(../assets/img/科技治超1.png) no-repeat center;
  background-size: cover;
  /* width: 43.7333vw; */
  width: 100%;
  /* height: 49.0667vw; */
  height: 100%;
  background-size: 100% 100%;
  background-size: cover;
  /* border: 1px dashed #808080; */
}

/* .airthree div:nth-child(2) {
  float: right;
  right: 0;
  background-image: url(../assets/img/智能安防3_mob.png);
  width: 44.2667vw;
  height: 69.0667vw;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center;
} */

/* .airthree div:nth-child(3) {
  float: left;
  margin-top: 4vw;
  right: 0;
  background-image: url(../assets/img/8.png);
  width: 44.2667vw;
  height: 16vw;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center;
} */
</style>



// WEBPACK FOOTER //
// src/components/architecture2.vue